import { Field as ChakraField, type FieldRootProps } from '@chakra-ui/react';
import * as React from 'react';

import { InfoTooltip } from '../info-tooltip';
import { type TooltipProps } from '../tooltip';

export interface FieldProps extends Omit<FieldRootProps, 'label'> {
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  errorText?: React.ReactNode;
  optionalText?: React.ReactNode;
  /** Tooltip content shown via an info icon beside the label. Requires `label` to be set. */
  info?: React.ReactNode;
  /** Extra props forwarded to the info `Tooltip`. */
  infoProps?: Omit<TooltipProps, 'content' | 'children'>;
}

export const Field = React.forwardRef<HTMLDivElement, FieldProps>(function Field(props, ref) {
  const { label, children, helperText, errorText, optionalText, info, infoProps, ...rest } = props;
  return (
    <ChakraField.Root ref={ref} {...rest}>
      {label && (
        <ChakraField.Label>
          {label}
          <ChakraField.RequiredIndicator fallback={optionalText} />
          {info != null && <InfoTooltip content={info} {...infoProps} />}
        </ChakraField.Label>
      )}
      {children}
      {helperText && <ChakraField.HelperText>{helperText}</ChakraField.HelperText>}
      {errorText && <ChakraField.ErrorText>{errorText}</ChakraField.ErrorText>}
    </ChakraField.Root>
  );
});
